module.exports = __webpack_public_path__ + "3af72af05702626e3e6d954fb7fab0ea.MP3";